export const GET_CLINIC_LIST_DATA =  'GET_CLINIC_LIST_DATA'
export const GET_CLINIC_LIST_DATA_SUCCESS =  'GET_CLINIC_LIST_DATA_SUCCESS'
export const GET_CLINIC_LIST_DATA_ERROR =  'GET_CLINIC_LIST_DATA_ERROR'
export const ACADEMY_TRAINING_LIST = "ACADEMY_TRAINING_LIST"
export const CLEAR_ACADEMY_TRAINING_LIST = "CLEAR_ACADEMY_TRAINING_LIST"